/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';
import { trackEvent } from '../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useExperimentImpressionEvent = (pathname) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const cookies = new Cookies();
        const experimentValue = cookies.get('ux-experiment') || '';
        const [experimentName = 'not defined', experimentCohort = ''] = experimentValue
            .split('|')
            .map((part) => part.trim());

        dispatch(trackEvent({
            eventName: 'experiment_impression',
            eventCategory: 'Experiment',
            eventAction: pathname,
            eventLabel: experimentCohort,
            feature_detail: experimentName,
            feature_element: experimentCohort,
            ga_event_name: 'experiment_impression',
        }));
    }, [pathname]);
};

export default useExperimentImpressionEvent;
